import { motion } from "framer-motion";

export default function AuroraBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-[#050814]" aria-hidden="true">
      <motion.div
        animate={{ x: [0, 60, 0], y: [0, -40, 0], scale: [1, 1.15, 1] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
        className="absolute -top-48 -left-48 w-[38rem] h-[38rem] rounded-full bg-[#0066FF]/25 blur-[120px]"
      />
      <motion.div
        animate={{ x: [0, -50, 0], y: [0, 50, 0], scale: [1, 1.2, 1] }}
        transition={{ duration: 26, repeat: Infinity, ease: "easeInOut", delay: 2 }}
        className="absolute top-1/3 -right-48 w-[34rem] h-[34rem] rounded-full bg-[#5E2BFF]/25 blur-[120px]"
      />
      <motion.div
        animate={{ x: [0, 40, 0], y: [0, -30, 0] }}
        transition={{ duration: 30, repeat: Infinity, ease: "easeInOut", delay: 5 }}
        className="absolute bottom-0 left-1/3 w-[30rem] h-[30rem] rounded-full bg-[#00F0FF]/10 blur-[120px]"
      />
      <div className="noise-overlay" />
    </div>
  );
}
